import { Component, OnInit,Input,Optional } from '@angular/core';
import { MediaService } from '../../../services/media.service';
import { AbstractControl, FormControl } from '@angular/forms';
import * as _ from 'lodash';
@Component({
  selector: 'app-docs-upload',
  templateUrl: './docs-upload.component.html',
  styleUrls: ['./docs-upload.component.scss']
})
export class DocsUploadComponent implements OnInit {
  docFiles:any;

  @Input() inputControl!: AbstractControl;
  @Input() collectionName!: string;
  @Input() mediaType!: string;
  @Input() documentId!: string;
  @Input() multiple!: boolean;
  @Optional() @Input() allowedFileMimeTypes!: any[];
  @Optional() @Input() allowedImageMimeTypes!: any[];
  @Optional() @Input() allowedVideoMimeTypes!: any[];

  constructor(private mediaService:MediaService) { }

  ngOnInit(): void {
  }

  onSelectDocs(event){

    console.log(event[0])
    const formData = new FormData();
    formData.append('directory', 'project');
    formData.append('file', event[0]);
    formData.append('Content-Type', 'application/json');
    formData.append('accept', 'application/json');
    console.log(formData)
    this.mediaService.uploadMedia(formData).subscribe(response => {
      console.log(response)
      this.docFiles = response
  
      console.log(this.docFiles)


      if (this.inputControl.value) {
        if (this.multiple) {
          let fileArray = _.cloneDeep(this.inputControl.value);
          fileArray = fileArray.concat(this.docFiles);
          this.inputControl.setValue(fileArray);
        } else {
          this.inputControl.setValue(this.docFiles);
        }
      } else {
        if (this.multiple) {
          this.inputControl.setValue(this.docFiles);
        } else {
          this.inputControl.setValue(this.docFiles);
        }
      }
  
    
  
      // this.documentsForm.value.infoItems.patchValue({
      //   attachment:this.docFiles
      // });
  
     // console.log(this.bannerImage)
  
      //this.thumbnail_image
      // this.subscriberDetailForm.patchValue({
      //   userDp : response.url
      // })
    });
  
  }

}
